import { List } from '@mui/material'
import _ from 'lodash'
import { useContext } from 'react'
import { FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { FilterableListBoxContext } from 'components/FilterableListBox'
import { createListItem } from './createListItem'
import { filterOptionsTree } from './utils'

import type { CheckboxTreeProps, Options } from './types'

export const CheckboxTree = <T extends FieldValues>({
  disabled,
  field,
  options,
}: CheckboxTreeProps<T>): JSX.Element => {
  const { t } = useTranslation('common')
  const { filter } = useContext(FilterableListBoxContext)

  const filteredOptions: null | Options = filterOptionsTree(options, filter)

  if (_.isEmpty(filteredOptions)) {
    return (
      <FlexBox
        axis='xy'
        p={2}
      >
        {t('filter.nothingFound')}
      </FlexBox>
    )
  }

  return (
    <List>
      {createListItem<T>({
        disabled,
        field,
        filter,
        options: filteredOptions,
        parentPath: undefined,
        recursionDeep: 0,
      })}
    </List>
  )
}
